import request from "@/utils/request";

export const  queryDict =(query) =>{
    return request({
        url: "/businessservice/museum/dict/queryList",
        method:"get",
        params: query
    })
}
// 分页查询推荐书目
export const pageBook = (data) => {
    return request({
        url: "/businessservice/museum/read/pageBook",
        method: "post",
        data: data
    })
}  

// 查询推荐书目信息
export const  infoBook =(query) =>{
    return request({
        url: "/businessservice/museum/read/infoBook",
        method:"get",
        params: query
    })
}

// 查询配置列表
export const  humItemList =(query) =>{
    return request({
        url: "/businessservice/museum/video/classifyList",
        method:"get",
        params: query
    })
}

// 查询主题信息及其子分类列表
export const  infoHumItem =(query) =>{
    return request({
        url: "/businessservice/museum/video/infoClassify",
        method:"get",
        params: query
    })
}

// 查询视频列表
export const  listHumVideo =(query) =>{
    return request({
        url: "/businessservice/museum/video/videoList",
        method:"get",
        params: query
    })
}

// 查询视频详情
export const  infoHumVideo =(query) =>{
    return request({
        url: "/businessservice/museum/video/videoInfo",
        method:"get",
        params: query
    })
}

export const  listItem =(data) =>{
    return request({
        url: "/businessservice/museum/item/list",
        method:"post",
        data: data
    })
}

// 分页查询推荐活动
export const pageEvent = (data) => {
    return request({
        url: "/businessservice/museum/read/pageEvent",
        method: "post",
        data: data
    })
}

// 查询推荐活动信息
export const  infoEvent =(query) =>{
    return request({
        url: "/businessservice/museum/read/infoEvent",
        method:"get",
        params: query
    })
}

// 分页查询主题活动
export const pageMuseumActivity = (data) => {
    return request({
        url: "/businessservice/museum/activity/page",
        method: "post",
        data: data
    })
}

// 查询主题活动信息
export const  infoMuseumActivity =(query) =>{
    return request({
        url: "/businessservice/museum/activity/info",
        method:"get",
        params: query
    })
}